import { render, staticRenderFns } from "./ShowImageModal.vue?vue&type=template&id=8f1a4cfa&scoped=true&"
import script from "./ShowImageModal.vue?vue&type=script&lang=js&"
export * from "./ShowImageModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowImageModal.vue?vue&type=style&index=0&id=8f1a4cfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1a4cfa",
  null
  
)

export default component.exports